import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { LogoIcon } from "assets/icons";
import { doResetPassword } from "stores/slices/auth";

import ResetPasswordForm from "components/forms/resetPasswordForm";

import styles from "./styles.module.scss";

const resetPasswordPage = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const navigate = useNavigate();

  const params = useParams();

  const [loading, setLoading] = useState(false);

  const handleSubmit = async values => {
    setLoading(true);

    const { payload } = await dispatch(
      doResetPassword({ ...values, id: params.id })
    );

    if (payload && payload.status === 200) {
      setTimeout(() => {
        navigate("/auth/sign-in");
      }, 1000);
    } else {
      setLoading(false);
    }
  };

  return (
    <div className={styles.authPage}>
      <div className={styles.authContent}>
        <div className={styles.authLogo}>
          <LogoIcon />
        </div>
        <div style={{ textAlign: "center" }}>
          <h1>{t("label.resetPassword")}</h1>
          <span>{t("text.resetPasswordMsg")}</span>
        </div>
        <div className={styles.authForm}>
          <ResetPasswordForm onSubmit={handleSubmit} loading={loading} />
        </div>
      </div>
    </div>
  );
};

export default resetPasswordPage;
